"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StageActorsPermissionsPopup = StageActorsPermissionsPopup;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _styles = require("@mui/material/styles");
var _core = require("@focaltec-suite/core");
var _DialogPopup = require("../components/DialogPopup");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var TitleBox = (0, _styles.styled)(_material.Box)(function (_ref) {
  var theme = _ref.theme;
  return {
    backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[900] : theme.palette.grey[200]
  };
});
function StageActorsPermissionsPopup(_ref2) {
  var stageActor = _ref2.stageActor,
    onUpdated = _ref2.onUpdated,
    onClose = _ref2.onClose,
    phaseTranslator = _ref2.phaseTranslator;
  var _useState = (0, _react.useState)(function () {
      var el = stageActor !== null && stageActor !== void 0 ? stageActor : {
        actors: [],
        stage_id: ''
      };
      el.actors.forEach(function (actor) {
        var _a;
        actor.actor_id = (_a = actor.actor_id) !== null && _a !== void 0 ? _a : '';
        actor.fields.forEach(function (field) {
          var _a, _b, _c, _d;
          field.field_id = (_a = field.field_id) !== null && _a !== void 0 ? _a : '';
          field.read = (_b = field.read) !== null && _b !== void 0 ? _b : false;
          field.write = (_c = field.write) !== null && _c !== void 0 ? _c : false;
          field.required = (_d = field.required) !== null && _d !== void 0 ? _d : false;
        });
      });
      return el;
    }),
    _useState2 = _slicedToArray(_useState, 2),
    request = _useState2[0],
    setRequest = _useState2[1];
  var onChangeCheckbox = function onChangeCheckbox(name, actorField, iActorFields, iActorField) {
    return function (event, checked) {
      var newField;
      if (name === 'read' && !checked) {
        newField = Object.assign(Object.assign({}, actorField), {
          read: false,
          write: false,
          required: false
        });
      } else if (name === 'write' && !checked) {
        newField = Object.assign(Object.assign({}, actorField), {
          write: false,
          required: false
        });
      } else {
        newField = Object.assign(Object.assign({}, actorField), _defineProperty({}, name, checked));
      }
      var newActors = request.actors.map(function (el, ai) {
        if (ai === iActorFields) {
          var fields = el.fields.map(function (fel, fi) {
            return fi === iActorField ? newField : fel;
          });
          return Object.assign(Object.assign({}, el), {
            fields: fields
          });
        }
        return el;
      });
      setRequest(Object.assign(Object.assign({}, request), {
        actors: newActors
      }));
    };
  };
  var checkbox = function checkbox(name, actorField, iActorFields, iActorField) {
    return /*#__PURE__*/_react["default"].createElement(_material.Typography, {
      component: "h5",
      align: "center"
    }, /*#__PURE__*/_react["default"].createElement(_material.Checkbox, {
      name: "".concat(iActorFields, "-").concat(iActorField, "_").concat(name),
      checked: actorField[name],
      disabled: name !== 'read' && !actorField.read || name === 'required' && !actorField.write,
      onChange: onChangeCheckbox(name, actorField, iActorFields, iActorField)
    }));
  };
  var onChangeAllCheckbox = function onChangeAllCheckbox(el, iActorFields) {
    return function (event, checked) {
      var newFields = el.fields.map(function (field) {
        return Object.assign(Object.assign({}, field), {
          read: checked,
          write: checked,
          required: checked
        });
      });
      var actorFields = Object.assign(Object.assign({}, el), {
        _checked: checked,
        fields: newFields
      });
      var newActors = request.actors.map(function (el, ai) {
        return ai === iActorFields ? actorFields : el;
      });
      setRequest(Object.assign(Object.assign({}, request), {
        actors: newActors
      }));
    };
  };
  var allCheckbox = function allCheckbox(actorFields, iActorFields) {
    return /*#__PURE__*/_react["default"].createElement(_material.FormGroup, {
      row: true
    }, /*#__PURE__*/_react["default"].createElement(_material.FormControlLabel, {
      label: /*#__PURE__*/_react["default"].createElement("small", null, (0, _core.translate)('workflove.popup.permission_all')),
      labelPlacement: "start",
      control: /*#__PURE__*/_react["default"].createElement(_material.Checkbox, {
        name: "".concat(iActorFields, "-actorField_all"),
        checked: actorFields._checked,
        onChange: onChangeAllCheckbox(actorFields, iActorFields)
      }),
      style: {
        marginBottom: '0'
      }
    }));
  };
  return /*#__PURE__*/_react["default"].createElement(_DialogPopup.DialogPopup, {
    title: (0, _core.translate)(phaseTranslator(stageActor._stage_external_id || '-', stageActor._stage_name || '-')),
    maxWidth: "md",
    closeText: (0, _core.translate)('buttons.cancel'),
    onClose: onClose,
    button: {
      text: (0, _core.translate)('buttons.update'),
      onClick: function onClick() {
        return onUpdated(request);
      }
    }
  }, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    variant: "body2",
    gutterBottom: true
  }, (0, _core.translate)('workflove.popup.subtitle')), request.actors.map(function (actorFields, yActorFields) {
    return /*#__PURE__*/_react["default"].createElement(_material.Grid, {
      key: yActorFields,
      container: true,
      sx: {
        mb: request.actors.length - 1 === yActorFields ? 2 : 0
      }
    }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/_react["default"].createElement(TitleBox, {
      mx: -3,
      mt: 1,
      mb: 2,
      px: 3
    }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
      container: true,
      justifyContent: "center",
      alignContent: "center",
      alignItems: "center"
    }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
      item: true,
      xs: true
    }, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
      variant: "body2",
      component: "h6"
    }, /*#__PURE__*/_react["default"].createElement("strong", null, actorFields._actor_name))), /*#__PURE__*/_react["default"].createElement(_material.Grid, {
      item: true,
      xs: "auto"
    }, allCheckbox(actorFields, yActorFields))))), /*#__PURE__*/_react["default"].createElement(_material.Grid, {
      item: true,
      xs: true
    }, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
      variant: "body2",
      color: "textSecondary",
      component: "h6",
      gutterBottom: true
    }, (0, _core.translate)('workflove.popup.field'))), /*#__PURE__*/_react["default"].createElement(_material.Grid, {
      item: true,
      xs: 4
    }, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
      variant: "body2",
      color: "textSecondary",
      component: "h6",
      gutterBottom: true
    }, (0, _core.translate)('workflove.popup.description'))), /*#__PURE__*/_react["default"].createElement(_material.Grid, {
      item: true,
      xs: 1
    }, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
      variant: "body2",
      color: "textSecondary",
      component: "h6",
      align: "center",
      gutterBottom: true
    }, (0, _core.translate)('workflove.popup.read'))), /*#__PURE__*/_react["default"].createElement(_material.Grid, {
      item: true,
      xs: 1
    }, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
      variant: "body2",
      color: "textSecondary",
      component: "h6",
      align: "center",
      gutterBottom: true
    }, (0, _core.translate)('workflove.popup.write'))), /*#__PURE__*/_react["default"].createElement(_material.Grid, {
      item: true,
      xs: 1
    }, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
      variant: "body2",
      color: "textSecondary",
      component: "h6",
      align: "center",
      gutterBottom: true
    }, (0, _core.translate)('workflove.popup.required'))), /*#__PURE__*/_react["default"].createElement(_material.Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/_react["default"].createElement(_material.Divider, null)), /*#__PURE__*/_react["default"].createElement(_material.Grid, {
      item: true,
      xs: 12
    }, actorFields.fields.map(function (actorField, iActorField) {
      return /*#__PURE__*/_react["default"].createElement(_material.Grid, {
        key: iActorField,
        container: true,
        justifyContent: "flex-start",
        alignContent: "center",
        alignItems: "center"
      }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
        item: true,
        xs: true
      }, actorField._field_name), /*#__PURE__*/_react["default"].createElement(_material.Grid, {
        item: true,
        xs: 4
      }, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
        variant: "caption"
      }, actorField._field_description || '---')), /*#__PURE__*/_react["default"].createElement(_material.Grid, {
        item: true,
        xs: 1
      }, checkbox('read', actorField, yActorFields, iActorField)), /*#__PURE__*/_react["default"].createElement(_material.Grid, {
        item: true,
        xs: 1
      }, checkbox('write', actorField, yActorFields, iActorField)), /*#__PURE__*/_react["default"].createElement(_material.Grid, {
        item: true,
        xs: 1
      }, checkbox('required', actorField, yActorFields, iActorField)));
    })));
  }));
}